module.exports = __webpack_public_path__ + "img/empty.3e64d788.webp";